import React from 'react';
import { Switch } from '@mui/material';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { toggleUserAPI } from '../../services/user';
import { USER_STATUS_UPDATE_FAILED, USER_STATUS_UPDATE_SUCCESS } from '../../helpers/messages';
import { CustomTooltip } from '../../consts';

const StatusChangeSwitch = ({ checked, user, onSuccess, disabled }) => {
    const [statusConfirmOpen, setStatusConfirmOpen] = React.useState(false);
    const [updatingUserStatus, setUpdatingUserStatus] = React.useState(null);
    const showSnackbar = useSnackbar();

    const handleStatusChangeConfirm = async () => {
        const formData = {
            Username: user.userId,
            Enabled: user.Enabled
        };
        try {
            setUpdatingUserStatus(true)
            await toggleUserAPI({ ...formData })
            setStatusConfirmOpen(false);
            setUpdatingUserStatus(false);
            onSuccess();
            showSnackbar(USER_STATUS_UPDATE_SUCCESS);
        } catch (error) {
            console.log(error);
            setUpdatingUserStatus(false)
            showSnackbar(USER_STATUS_UPDATE_FAILED, "error");
        }
    };

    const renderConfirm = () => {
        const name = user?.firstname ? (user?.firstname + " " + user?.lastname) : user?.email;

        return (<ConfirmDialog
            open={statusConfirmOpen}
            loading={updatingUserStatus}
            onClose={() => setStatusConfirmOpen(false)}
            onConfirm={handleStatusChangeConfirm}
            title="User Status Update"
            okText='Ok'
            message={`Are you sure you want to ${user.Enabled ? "inactivate" : "activate"} the user ${name}?`}
        />)
    }

    const handleStatusChangeAction = (e) => {
        if (disabled && checked) {
            showSnackbar("Disabling your account is not allowed.", "error");
            return;
        }
        setStatusConfirmOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={checked ? "Active" : "Inactive"}>
                <span>
                    <Switch
                        inputProps={{ 'aria-label': checked ? "Active" : "Inactive" }}
                        checked={checked}
                        onChange={(e) => handleStatusChangeAction(e)}
                        sx={{marginLeft: -1.25}}
                    />
                </span>
            </CustomTooltip>
        </>
    )
}

export default StatusChangeSwitch